import React from "react";
import TransactionCards from "./TransactionCards";
import { useDispatch, useSelector } from "react-redux";
import { getUserTransaction } from "../CrudAndRedux/ProfileCrud";
import { actions } from "../CrudAndRedux/ProfileRedux";
import TransactionSearchCard from "./TransactionSearchCard";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const Transaction = (props) => {
  let { state } = useSelector((state) => ({
    state: state.search,
  }));

  let { state: profileState } = useSelector((state) => ({
    state: state.profile,
  }));

  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));

  const dispatch = useDispatch();

  React.useEffect(() => {
    getUserTransaction(authState.user.token).then((res) =>
      dispatch(actions.getAllTransactions(res.data.data))
    );
  }, []);

  return (
    <div className="p-5">
      <TransactionSearchCard />
      {profileState.transactions ? (
        <TransactionCards />
      ) : (
        <div style={{ marginTop: "1rem" }} className="container">
          <SkeletonTheme
            baseColor="#d9dce6"
            className="container"
            highlightColor="darkgray"
          >
            <Skeleton count={5} style={{ height: "10rem", marginBlock: 10 }} />
          </SkeletonTheme>
        </div>
      )}
    </div>
  );
};

export default Transaction;
